import { createContentPropTypes } from '../../helpers/content';

const content = {
	name: 'Name',
	paymentTimedOutModalTitle: "Sorry, there's been a technical problem.",
	paymentTimedOutInfoText: 'It looks like something has gone wrong in the background.',
	paymentStatusInfoText:
		'Your payment(s) may still have been processed, so please check the status, and if necessary, resubmit. If you are still having problems, please get in touch.',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
